import $ from 'jquery';
import 'jquery-sticky/jquery.sticky';
import { MQ } from '../tools/MQ';

export const init = () => {
	$(window)
		.on('resize', function() {
			$('.is-sticky').each(function() {console.log("X");
				var $content = $('.b-content');
				if ( $content.length > 0 ) {
					if ( MQ('mdUp') ) {
						$('.is-sticky').sticky({
							topSpacing: 100,
							bottomSpacing: $(document).height() - $('.b-content').offset().top - $('.b-content').outerHeight(),
						});
					}
				}
			});
		});

	$(window).trigger('resize');
};




// WEBPACK FOOTER //
// ./src/js/components/stickyOffer.js